export default "__VITE_ASSET__xIJtyG3N__"